import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Radio, Users } from "lucide-react";

export const LiveStats = ({ className = "" }) => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let active = true;
    const fetchStats = () => api.get("/stats").then((r) => { if (active) setStats(r.data); }).catch(() => {});
    fetchStats();
    const id = setInterval(fetchStats, 15000);
    return () => { active = false; clearInterval(id); };
  }, []);

  return (
    <div data-testid="live-stats" className={`inline-flex items-center gap-4 border border-cyan-500/20 bg-[#11111A] px-4 py-2 ${className}`}>
      <span className="inline-flex items-center gap-2 font-arcade text-base text-[#00F0FF]">
        <span className="relative flex h-2.5 w-2.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#00F0FF] opacity-70" />
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#00F0FF]" />
        </span>
        <Radio className="w-4 h-4" />
        <span data-testid="stats-online">{stats ? stats.online : "—"}</span> PLAYING NOW
      </span>
      <span className="w-px h-4 bg-slate-700" />
      <span className="inline-flex items-center gap-2 font-arcade text-base text-[#F5C842]">
        <Users className="w-4 h-4" />
        <span data-testid="stats-members">{stats ? stats.members : "—"}</span> MEMBERS
      </span>
    </div>
  );
};
